<template>
    <v-layout class="flex-column px-3">
        <div class="my-3 scan-header">ADMIN DASHBOARD</div>
        <v-item-group mandatory @change="changeTab">
            <div class="d-flex flex-row flex-wrap">
                <div v-for="(n, index) in tabs" :key="index" class="pa-2">
                    <v-item v-slot="{ active, toggle }">
                        <v-card
                                :color="active ? 'primary' : '#f4f6f8'"
                                class="d-flex align-center justify-center px-4 py-2"
                                height="36"
                                dark
                                flat
                                outlined
                                @click="toggle"
                        >
                            <v-scroll-y-transition>
                                <div v-if="active" >{{n.name}}</div>
                                <div v-if="!active" style="color: #411F90">{{n.name}}</div>
                            </v-scroll-y-transition>
                        </v-card>
                    </v-item>
                </div>
            </div>
        </v-item-group>
        <ClientsDashboard v-if="currentTab === 0"/>
        <UsersDashboard v-if="currentTab === 1"/>
        <WebsitesDashboard v-if="currentTab === 2"/>
        <CategoriesDashboard v-if="currentTab === 3"/>
        <ProxyRegionsDashboard v-if="currentTab === 4"/>
        <AllowedVendorsDashboard v-if="currentTab === 5"/>
        <VendorsManagementDashboard v-if="currentTab === 6"/>
        <BenchmarksDashboard v-if="currentTab === 7"/>
      <!--        <LighthouseDashboard v-if="currentTab === 8"/>-->
      <!--        <TableauUrlsDashboard v-if="currentTab === 9"/>-->
    </v-layout>
</template>

<script>
    import ClientsDashboard from "../components/admin/ClientsDashboard";
    import WebsitesDashboard from "../components/admin/WebsitesDashboard";
    import UsersDashboard from "../components/admin/UsersDashboard";
    import ProxyRegionsDashboard from "../components/admin/ProxyRegionsDashboard";
    import AllowedVendorsDashboard from "../components/admin/allowedVendors/AllowedVendorsDashboard";
    import VendorsManagementDashboard from "../components/admin/vendorsManagement/VendorsManagementDashboard";
    import BenchmarksDashboard from "../components/admin/benchmarks/BenchmarksDashboard";
    import CategoriesDashboard from "../components/admin/CategoriesDashboard";
    // import LighthouseDashboard from "../components/admin/LighthouseDashboard";
    // import TableauUrlsDashboard from "../components/admin/TableauUrlsDashboard";
    export default {
        name: "AdminDashboard",
        components: {UsersDashboard,WebsitesDashboard, ClientsDashboard, ProxyRegionsDashboard, AllowedVendorsDashboard,VendorsManagementDashboard, BenchmarksDashboard, CategoriesDashboard
          // TableauUrlsDashboard, LighthouseDashboard,
        },
        data: () => ({
            currentTab: 0,
            tabs: [
                {id: 0, name: 'CLIENTS'},
                {id: 1, name: 'USERS'},
                {id: 2, name: 'WEBSITES'},
                {id: 3, name: 'CATEGORIES'},
                {id: 4, name: 'PROXY REGIONS'},
                {id: 5, name: 'ALLOWED VENDORS'},
                {id: 6, name: 'VENDORS MANAGEMENT'},
                {id: 7, name: 'BENCHMARKS'},
                // {id: 8, name: 'LIGHTHOUSE'},
                // {id: 9, name: 'TABLEAU URLS'},
            ],
        }),
        methods: {
            changeTab(e){
                this.currentTab = e;
            },
        }
    }
</script>
